import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import type { RootState } from "@/store";

export type ArticlesReducerState = {
  search: Nullable<string>;
  customerId: Nullable<string>;
  projectId: Nullable<string>;
  ownerId: Nullable<string>;
  categories: string[];
  tags: string[];
  articleType: KnowledgebaseNgArticleType[];
  status: KnowledgebaseNgArticleStatus[];
};

const initialState: ArticlesReducerState = {
  search: null,
  customerId: null,
  projectId: null,
  ownerId: null,
  categories: [],
  tags: [],
  articleType: [],
  status: [],
};

const knowledgebaseNgArticlesSlice = createSlice({
  name: "knowledgebaseNg/articles",
  initialState,
  reducers: {
    setSearch(state, { payload }: PayloadAction<Nullable<string>>) {
      state.search = payload;
    },

    setCustomerId(state, { payload }: PayloadAction<Nullable<string>>) {
      state.customerId = payload;
    },

    setProjectId(state, { payload }: PayloadAction<Nullable<string>>) {
      state.projectId = payload;
    },

    setOwnerId(state, { payload }: PayloadAction<Nullable<string>>) {
      state.ownerId = payload;
    },

    setCategories(state, { payload }: PayloadAction<string[]>) {
      state.categories = payload;
    },

    setTags(state, { payload }: PayloadAction<string[]>) {
      state.tags = payload;
    },

    setArticleType(state, { payload }: PayloadAction<KnowledgebaseNgArticleType[]>) {
      state.articleType = payload;
    },

    setStatus(state, { payload }: PayloadAction<KnowledgebaseNgArticleStatus[]>) {
      state.status = payload;
    },

    resetFilters(state) {
      state.search = null;
      state.customerId = null;
      state.projectId = null;
      state.ownerId = null;
      state.categories = [];
      state.tags = [];
      state.articleType = [];
      state.status = [];
    },
  },
});

export const {
  setSearch,
  setCustomerId,
  setProjectId,
  setOwnerId,
  setCategories,
  setTags,
  setArticleType,
  setStatus,
  resetFilters,
} = knowledgebaseNgArticlesSlice.actions;
export const articlesSelector = (state: RootState) => state.knowledgebaseNg.articles;
export default knowledgebaseNgArticlesSlice.reducer;
